import { FC } from 'react';
import './index.scss';
import { LoginForm } from '@/components/auth';

const LoginPage: FC = () => {
  return <LoginForm />;
};

export default LoginPage;
